import labels from "emun.invoice/credit-request/_labels";
import config from "emun.invoice/credit-request/credit-request.config";
import SendEmailPromptController from "servicestack/email/send-email-prompt.controller";
import modals from "webmodals/modals";

export default class CreditRequestPromptController extends SendEmailPromptController {
  constructor($uibModalInstance, options) {
    super($uibModalInstance, options);
    const $ctrl = this;
    if (config.creditRequestEmail && !$ctrl.model.customerServiceAreaId)
      $ctrl.model.customerServiceAreaId = config.creditRequestEmail;
  }

  getCommandUrl() {
    const $ctrl = this;
    console.debug("CreditRequestPromptController", $ctrl.model);
    return `${
      $ctrl.model.id ? "Upd" : "Cre"
    }ateCreditMemoRequest.json?CreditRequestPromptController&jsconfig=ua,uaa`;
  }

  onSubmitted(res) {
    super.onSubmitted(res);
    const $ctrl = this;
    if ($ctrl.options.transitionTo) {
      $ctrl.$state.transitionTo($ctrl.options.transitionTo, {
        retailerId: $ctrl.options.retailerId,
        id: res.data.id,
      });
    }
  }

  delete() {
    const $ctrl = this;
    $ctrl.$close($ctrl.model);
    return modals
      .confirm("Are you sure?", "Delete " + labels.name)
      .result.then(() =>
        $ctrl.bus.send("DeleteCreditMemoRequest.json", $ctrl.model)
      );
  }
}
